<script>
	import { getContext } from 'svelte';

	const theme = getContext('theme');
</script>

<style>
	footer {
		background-color: var(--pale);
		padding-bottom: 72px;
		padding-top: 36px;
		font-size: 18px;
	}
	a {
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		color: #595959;
		text-decoration: underline;
		display: inline-block;
	}
	a:hover {
		color: #222;
		text-decoration: none;
	}
	a:active {
		outline: 3px solid transparent;
		background-color: #fd0;
		-webkit-box-shadow: 0 -2px #fd0, 0 4px #222;
		box-shadow: 0 -2px #fd0, 0 4px #222;
		color: #222;
		text-decoration: none;
	}
	ul {
		padding: 0;
		margin: 0;
	}
	li {
		margin-right: 18px;
		display: inline-block;
	}
	hr {
		margin-bottom: 27px;
		margin-top: 36px;
		border: 0;
		border-top: 1px solid #888;
	}
	.logo-img {
		margin-bottom: 27px;
	}
	.svg-icon {
		width: 18px;
		vertical-align: middle;
		margin: 0 0 0 4.5px;
		fill: #595959;
	}
	.ogl-img {
		margin: 0 0.5rem 0.2rem 0;
	}
	.license {
		vertical-align: top;
	}
</style>

<footer>
	<div class="col-wide" data-analytics="footer">
		{#if theme == 'dark'}
		<img
			class="logo-img"
			src="https://ons-design-system.netlify.app/img/ons-logo-neg-en.svg"
			alt="Office for National Statistics" />
		{:else}
		<img
			class="logo-img"
			src="https://ons-design-system.netlify.app/img/ons-logo-black-en.svg"
			alt="Office for National Statistics" />
		{/if}
		<ul>
			<li><a href="#0" class="list__link ">Contact us</a></li>
			<li><a href="#0" class="list__link ">Cookies and privacy</a></li>
		</ul>
		<hr />
		<div class="license">
			<img
				class="ogl-img"
				src="https://ons-design-system.netlify.app/img/UKOpenGovernmentLicence-grey.svg"
				alt="Open Government Licence" />
			All content is available under the
			<a
				href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/"
				class="external-link"
				target="_blank"
				rel="noopener">Open Government Licence v3.0
				<svg
					id="external-link"
					class="svg-icon"
					viewBox="0 0 12 12"
					xmlns="http://www.w3.org/2000/svg">
					<path
						d="M13.5,9H13a.5.5,0,0,0-.5.5v3h-9v-9h3A.5.5,0,0,0,7,3V2.5A.5.5,0,0,0,6.5,2h-4a.5.5,0,0,0-.5.5v11a.5.5,0,0,0,.5.5h11a.5.5,0,0,0,.5-.5v-4A.5.5,0,0,0,13.5,9Z"
						transform="translate(-2 -1.99)" />
					<path
						d="M8.83,7.88a.51.51,0,0,0,.71,0l2.31-2.32,1.28,1.28A.51.51,0,0,0,14,6.49v-4a.52.52,0,0,0-.5-.5h-4A.51.51,0,0,0,9,2.52a.58.58,0,0,0,.14.33l1.28,1.28L8.12,6.46a.51.51,0,0,0,0,.71Z"
						transform="translate(-2 -1.99)" />
				</svg>
			</a>
			, except where otherwise stated
		</div>
	</div>
</footer>
